/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientCommsOverlay/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientCommsOverlay({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsOverlay"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let commsThreadIdValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'thread_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(commsThreadIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}